import React from "react";

function Invoice3WithVat({ general, data }) {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDateSlash = `${month}/${day}/${year}`;

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  let currentTime = `${hours}:${minutes}:${seconds}`;

  function formatDate(inputDate) {
    // Split date and time
    const [date] = inputDate.split(" ");
    // Split year, month, and day
    const [year, month, day] = date.split("-");
    // Return formatted date as MM/DD/YYYY
    return `${month}/${day}/${year}`;
  }
  return (
    <>
      <div className="w-full max-w-3xl mx-auto py-8 px-16">
        <h1 className="text-4xl font-medium text-center mt-6">
          {general.restaurant_name}
        </h1>
        <div className="text-center text-2xl mt-2">
          <p>{general.address}</p>
          <p>Tel: {general.phone}</p>
          <p>Simplified Tax Invoice</p>
        </div>
        <p className="mt-2 text-2xl text-center">
          Tax Registration No: {general.tax_reg_no}
        </p>
        <div className="mt-4">
          <span className="mx-auto py-1 border-4 text-lg border-black px-2 min-w-64 w-fit text-center block font-bold">
            Order # {Number(data.token_no)}
            {data.table?.name && (
              <p className="text-lg font-semibold text-center my-2">
                Table # {data.table?.name}
              </p>
            )}
          </span>
        </div>
        <p className="text-center text-xl mt-2">
          Printed At: {`${currentDateSlash} ${currentTime}`}
        </p>
        <div className="pt-2 border-t-2 border-b-2 border-black text-xl flex gap-4 justify-between">
          <div>
            <p> {data.order_type?.type}</p>
          </div>
          <div className="text-end">
            <p>Check# {data.token_no}</p>
            <p>{`${formatDate(data.sale_date)} ${data.order_time}`}</p>
          </div>
        </div>
        <div className="text-end border-b text-xl py-1">
          <p>
            Customer Name:{" "}
            {data.is_guest === "no" ? data.customer?.name : data.guest?.name}
          </p>
          {data.order_type_id === 2 && (
            <p>
              Cutomer Number:{" "}
              {data.is_guest === "no"
                ? data.customer?.phone
                : data.guest?.phone}
            </p>
          )}
        </div>
        <table className="w-full text-xl">
          <thead>
            <tr className="border-b-4 border-black">
              <th className="py-1 text-start">Qty</th>
              <th className="py-1 text-start">Item</th>
              <th className="py-1 text-start">VAT</th>
              <th className="py-1 text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.order_details?.map((orderItem, index) => (
              <>
                <tr
                  key={index}
                  className={
                    orderItem.modifiers.length === 0 &&
                    `border-b-2 ${
                      data.order_details.length - 1 === index && "border-black"
                    }`
                  }
                >
                  <td>{orderItem.qty}</td>
                  <td>
                    <p>
                      {orderItem.name} / {orderItem.name_arabic}
                    </p>
                  </td>
                  <td>
                    {orderItem.menu_taxes.additional_vat_percentage === 100
                      ? `T(${
                          orderItem.menu_taxes.additional_vat_percentage
                        }%) ${orderItem.menu_taxes.vat.toFixed(2)}`
                      : orderItem.menu_taxes.vat_percentage === 15
                      ? `V(${
                          orderItem.menu_taxes.vat_percentage
                        }%) ${orderItem.menu_taxes.vat.toFixed(2)}`
                      : orderItem.menu_taxes.vat_percentage === 0
                      ? `Z(${
                          orderItem.menu_taxes.vat_percentage
                        }%) ${orderItem.menu_taxes.vat.toFixed(2)}`
                      : "Exemption"}
                  </td>
                  <td className="text-end">
                    {orderItem.menu_unit_price_with_vat.toFixed(2) ===
                    orderItem.menu_price_with_discount.toFixed(2) ? (
                      <p>{orderItem.menu_unit_price_with_vat.toFixed(2) * orderItem.qty}</p>
                    ) : (
                      <span className="flex gap-2">
                        <p className="line-through">
                          {orderItem.menu_unit_price_with_vat.toFixed(2) * orderItem.qty}
                        </p>
                        <p>{orderItem.menu_price_with_discount.toFixed(2) * orderItem.qty}</p>
                      </span>
                    )}
                  </td>
                </tr>
                {orderItem.food_menu.is_deal === "yes" && (
                    <tr>
                      <td colSpan={5}>
                        {orderItem.food_menu.deal_details && JSON.parse(orderItem.food_menu.deal_details)?.map((deal, index) => (
                          <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                        ))}
                      </td>
                    </tr>
                  )}
                {orderItem.modifiers.map((mod, index) => (
                  <tr
                    key={index}
                    className={
                      orderItem.modifiers.length === index + 1 &&
                      `border-b-2 ${
                        data.order_details.length - 1 === index &&
                        "border-black"
                      }`
                    }
                  >
                    <td colSpan={3}>{mod.name}</td>
                    <td className="text-end">{mod.price * orderItem.qty}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
          <tbody className="font-medium">
            <tr className="border-b-2">
              <td colSpan={3}>VAT</td>
              <td className="text-end">SAR {data.vat_amount.toFixed(2)}</td>
            </tr>
            <tr className="border-b-2">
              <td colSpan={3}>Total</td>
              <td className="text-end">SAR {data.total_payable.toFixed(2)}</td>
            </tr>
            {data.total_discount_amount !== 0 && (
              <tr className="border-b-2">
                <td colSpan={3}>Total Discount</td>
                <td className="text-end">
                  SAR {data.total_discount_amount.toFixed(2)}
                </td>
              </tr>
            )}
            {data.delivery_charges !== 0 && (
              <tr className="border-b-2">
                <td colSpan={3}>Service/Delivery</td>
                <td className="text-end">
                  SAR {data.delivery_charges.toFixed(2)}
                </td>
              </tr>
            )}
            <tr className="border-b-2">
              <td colSpan={3}>Payment - Cash</td>
              <td className="text-end">SAR {data.total_payable.toFixed(2)}</td>
            </tr>
            <tr className="border-b-2">
              <td colSpan={3}>Received Amount</td>
              <td className="text-end">SAR {data.received_amount || 0}</td>
            </tr>
            <tr className="border-b-2">
              <td colSpan={3}>Change Amount</td>
              <td className="text-end">SAR {data.change_amount || 0}</td>
            </tr>
            <tr className="text-center border-b-2 border-black">
              <td colSpan={4}>{data.order_details.length}</td>
            </tr>
          </tbody>
        </table>
        <div className="text-xl text-center mt-16">
          <p>{general.phone}</p>
          <img src={data.qr_image_url} className="w-64 mx-auto mt-8" alt="" />
        </div>
      </div>
    </>
  );
}

export default Invoice3WithVat;
